
import Hero from "../components/Hero";
import TargetAudience from "../components/TargetAudience";
import Features from "../components/Features";
import Vision from "../components/Vision";
import ResponsibleAI from "../components/ResponsibleAI";

const Index = () => {
  return (
    <>
      <Hero />
      <TargetAudience />
      <Features />
      <Vision />
      <ResponsibleAI />
    </>
  );
};

export default Index;
